/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Track_Intensity_Hot_DescInputs */

const en_ui_track_intensity_hot_desc = /** @type {(inputs: Ui_Track_Intensity_Hot_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every pass at full strength – busy areas saturate fast.`)
};

const de_ui_track_intensity_hot_desc = /** @type {(inputs: Ui_Track_Intensity_Hot_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Runde in voller Stärke – wo du oft trainierst, strahlt es schnell weiß.`)
};

/**
* | output |
* | --- |
* | "Every pass at full strength – busy areas saturate fast." |
*
* @param {Ui_Track_Intensity_Hot_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_track_intensity_hot_desc = /** @type {((inputs?: Ui_Track_Intensity_Hot_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Track_Intensity_Hot_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_track_intensity_hot_desc(inputs)
	return de_ui_track_intensity_hot_desc(inputs)
});